// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"546":"e5f1b476","700":"45ba1cc6","855":"358d8fc1"}[chunkId] + ".chunk.js";
};